<template>
    <form ref="createNews">

        <vs-input
            class="w-full"
            v-model="dataNewNews.title"
            :placeholder="$t('title')"
            name="news_title"
            v-validate="'required'"
        ></vs-input>
        <span
            class="text-danger text-sm"
            v-show="errors.has('news_title')"
            >
            {{ $t("validation_required") }}
        </span >
        <div class="mt-4">
            <vs-textarea
                v-model="dataNewNews.content"
                :label="$t('description')"
                name="news_desc"
                v-validate="'required'"
            ></vs-textarea>
            <span
                class="text-danger text-sm"
                v-show="errors.has('news_desc')"
                >{{ $t("validation_required") }}</span
            >
        </div>

        <div class="vx-col w-full">

            <label class="vs-input--label">{{
                $t("news_title_photo")
            }}</label>

            <vs-upload v-if="trueUpload" :action="'common/upload/'" @on-success="setImage"
                @prev-delete="removeFile" single-upload :limit="1" automatic :max-size="10" :firstFiles="filesNews"
                :text="$t('select_a_file')" :fileName="'path'" />

        </div>
        <vs-button color="primary" @click="postNews">{{
            getNewsUpdate.is_update ? $t('edit') :  $t("create")
        }}</vs-button>

    </form>
</template>

<script>
import { mapGetters } from "vuex";

    export default {
        data() {
            return {
                trueUpload: true,
                filesNews: [],
                dataNewNews: {
                    uid:"",
                    title: "",
                    content: null,
                    image: null,
                    student_club: "",
                },
            }
        },
        computed: {
            uid() {
                return this.$route.query.uid;
            },

            //все данные приходят от стр NewsCard.vue при нажатии кнопака редакт
            getNewsUpdate() {
                try{
                    var value =  this.$store.getters['studclubs/editNews'];
                        if(value.uid){
                            this.dataNewNews.title = value.title;
                            this.dataNewNews.content = value.content;
                            this.dataNewNews.image = value.image;
                            this.dataNewNews.uid = value.uid;
                            this.filesNews = value.images;
                        }else{
                            this.dataNewNews.student_club = this.uid
                        }

                        //trueUpload  нужен для перезагузки vs-upload 
                        //если работать без него то измиение данных в vs-upload небудут работать 
                        //его приходится то показывать то скрывать при каждом изминении 
                    this.trueUpload = false
                    
                    setTimeout(() => {
                        this.trueUpload = true
                    }, 500);

                    return value;
                }
                catch{
                      this.$vs.notify({
                        title: this.$t("error"),
                        text: this.$t("Fillallfields"),
                        color: "danger",
                    });
                }
            }
        },
        methods: {
            // Добавление файла для нвоостей
            setImage(response){
                this.dataNewNews.image = response[0].uid;
            },
            // Удаление файла для нвостей
            async removeFile({ file, done }) {
                this.filesNews = await this.filesNews.filter(
                    (item) => item.response.uid !== file.response.uid
                );
                done();
            },

            // Создать новость
            async postNews() {
                this.$validator.validateAll().then(async (result) => {
                    if (result) {
                        this.$vs.loading();
                        let res;
                        if(this.getNewsUpdate.is_update){
                            res = await this.$http.put(
                                `/student_clubs/news/${ this.dataNewNews.uid }/?student_club=${ this.uid }`,
                                this.dataNewNews);
                        }else {
                            res = await this.$http.post(
                                `/student_clubs/news/`,
                                this.dataNewNews
                            ); 
                        }
                        if (res.status === 200 || res.status === 201) {
                            this.$vs.notify({
                                title: this.$t("succesful"),
                                text: this.$t("created"),
                                color: "primary",
                            });
                        }

                        //закрыть popup и загузить данные по новому
                        this.$emit('closePopup');

                        //set default state
                        this.clearDataNewNews();
                      
                    } else {
                        this.$vs.notify({
                            title: this.$t("error"),
                            text: this.$t("Fillallfields"),
                            color: "danger",
                        });
                    }
                    this.$vs.loading.close();
                });
            },

            clearDataNewNews(){
                this.dataNewNews = {
                    title: "",
                    content: "",
                    image: null,
                    student_club: "",
                };
            }

        }
    }
</script>